import { useState } from 'react';
import { PreviewPanel } from '../PreviewPanel';
import { EffectClipDialog } from '../EffectClipDialog';
import { MobileEditorTopBar } from './MobileEditorTopBar';
import { MobileTransportBar } from './MobileTransportBar';
import { MobileClipActions } from './MobileClipActions';
import { MobileTimelinePanel } from './MobileTimelinePanel';
import { MobileBottomTabBar, type MobileTab } from './MobileBottomTabBar';
import { MobileMediaSheet } from './MobileMediaSheet';
import { MobileFXSheet } from './MobileFXSheet';
import { MobileAudioMixerSheet } from './MobileAudioMixerSheet';
import { MobileExportSheet } from './MobileExportSheet';
import { useKeyboardShortcuts } from '../../hooks/useKeyboardShortcuts';
import { useEffectsSync } from '../../hooks/useEffectsSync';
import { useAutoSave } from '../../hooks/useAutoSave';

export function MobileEditorLayout() {
  useKeyboardShortcuts();
  useEffectsSync();
  useAutoSave();

  const [activeTab, setActiveTab] = useState<MobileTab>('edit');
  const [sheetOpen, setSheetOpen] = useState<MobileTab | null>(null);

  const handleTabChange = (tab: MobileTab) => {
    setActiveTab(tab);
    if (tab === 'edit') {
      setSheetOpen(null);
    } else {
      setSheetOpen(tab);
    }
  };

  const handleCloseSheet = () => {
    setSheetOpen(null);
    setActiveTab('edit');
  };

  return (
    <div
      className="flex flex-col bg-[var(--user-page-bg)] text-[var(--user-page-text)] overflow-hidden"
      style={{ height: '100dvh' }}
    >
      <MobileEditorTopBar />

      {/* Preview — flex-1 so it fills remaining space */}
      <div className="flex-1 min-h-0">
        <PreviewPanel />
      </div>

      <MobileTransportBar />

      {/* Clip actions — appears when a clip is selected */}
      <MobileClipActions />

      {/* Timeline area — fixed height */}
      <div className="shrink-0" style={{ height: 180 }}>
        <MobileTimelinePanel />
      </div>

      <MobileBottomTabBar activeTab={activeTab} onChange={handleTabChange} />

      {/* Bottom sheets */}
      <MobileMediaSheet isOpen={sheetOpen === 'media'} onClose={handleCloseSheet} />
      <MobileFXSheet isOpen={sheetOpen === 'fx'} onClose={handleCloseSheet} />
      <MobileAudioMixerSheet isOpen={sheetOpen === 'audio'} onClose={handleCloseSheet} />
      <MobileExportSheet isOpen={sheetOpen === 'export'} onClose={handleCloseSheet} />

      <EffectClipDialog />
    </div>
  );
}
